
<div class="form-group" style="padding-left: 0; padding-right: 0; padding-bottom: 0;">
  <label for="date">Date</label>
  <input [owlDateTime]="dt1" [owlDateTimeTrigger]="dt1" type="text" placeholder="JJ/MM/AAAA" [formControl]="document.date" style="width: 100px;"/>
  <owl-date-time pickerType="calendar" firstDayOfWeek="1" pickerMode="dialog" #dt1></owl-date-time>
</div>

<div class="form-group" style="padding-left: 0; padding-right: 0;">
  <label for="comment">Commentaire</label>
  <input id="comment" type="text" placeholder="" [formControl]="document.comment"/>
</div>
